import type { TranscriptSnippet } from "@expert/shared-types";

/*
 * Theres no guarantee that snippets will come in order. We need to handle this
 */
export const mergeSnippets = (
    sortedSnippets: TranscriptSnippet[] | undefined,
    newSnippets: TranscriptSnippet[] | undefined,
) => {
    // if no new snippets, return existing snippets unchanged
    if (!newSnippets || newSnippets.length === 0) return sortedSnippets;

    newSnippets.sort((a, b) => a.timestamp - b.timestamp);

    // if no existing snippets, return new snippets after they are sorted
    if (!sortedSnippets) return newSnippets;

    // now we have existing snippets and new snippets and they are all sorted ascending
    // iterate through each snippet and find its spot

    const mergedArray: TranscriptSnippet[] = [];
    let i = 0;
    let j = 0;

    // Traverse both arrays and merge them in sorted order
    while (i < sortedSnippets.length && j < newSnippets.length) {
        if (sortedSnippets[i].timestamp <= newSnippets[j].timestamp) {
            mergedArray.push(sortedSnippets[i]);
            i++;
        } else {
            mergedArray.push(newSnippets[j]);
            j++;
        }
    }

    // If there are remaining elements in arr1, add them to mergedArray
    while (i < sortedSnippets.length) {
        mergedArray.push(sortedSnippets[i]);
        i++;
    }

    // If there are remaining elements in arr2, add them to mergedArray
    while (j < newSnippets.length) {
        mergedArray.push(newSnippets[j]);
        j++;
    }

    return mergedArray;
};
